import { useSelector } from 'react-redux'
import { IAuth } from '../Interfaces/state.interface'

export function useAuth() {
  const { role, name, id, avatar, position } = useSelector((state: { auth: IAuth }) => state.auth)

  return {
    role,
    name,
    id,
    avatar,
    position
  }
}
